import { slideDown, slideUp } from './animations.js';

export function accordionInit() {
    document.querySelectorAll('.js-accordion, .js-accordion-button').forEach(elem => {
        elem.addEventListener('click', accordionClick);
    });
}

function accordionClick(e) {
    const accordionTitle = e.currentTarget;
    const accordion = accordionTitle.closest('.c-accordion__single');
    const hiddenContent = accordion.querySelector('.c-accordion__hidden');

    if (accordion.classList.contains('c-accordion-open')) {
        slideUp(hiddenContent, 300);
        accordion.classList.toggle('c-accordion-open');
        accordion.setAttribute('data-state', 'closed');
        accordionTitle.setAttribute('aria-expanded', 'false');
    } else {
        slideDown(hiddenContent, 300);
        accordion.classList.toggle('c-accordion-open');
        accordion.setAttribute('data-state', 'open');
        accordionTitle.setAttribute('aria-expanded', 'true');
    }
}